import { ApiCall } from "../helper/axios";
import { toast } from "../common_components/Toast/ToastUtils";
// ✅ Common module key
const MODULE_KEY = "account_summary";
class AccountSummaryService {
    async getAllAccountSummary(params, token) {
        const response = await ApiCall("POST", "/api/account-summary/view", params, {
            Authorization: token,
            modulekey: MODULE_KEY,
            "x-module-key": MODULE_KEY,
        });
        if (response && typeof response === "object" && "data" in response) {
            return response.data;
        }
        throw new Error("Failed to fetch all clients account summary");
    }
    async getSingleAccountSummary(clientId, params, token) {
        const response = await ApiCall("POST", `/api/account-summary/view/${clientId}`, params, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && typeof response === "object" && "data" in response) {
            return response.data;
        }
        throw new Error("Failed to fetch single client account summary");
    }
    async refreshAccountSummary(token) {
        const response = await ApiCall("GET", "/api/account-summary/refresh", {}, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            toast.success("Account Summary refreshed successfully!");
            return response.data;
        }
        toast.error("Failed to refresh account summary");
        throw new Error("Failed to refresh account summary");
    }
    async triggerHourlyCron(params, token) {
        const response = await ApiCall("POST", "/api/cron/trigger-hourly", params, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to trigger hourly cron");
    }
    async getCronStatus(token) {
        const response = await ApiCall("GET", "/api/cron/status", "", {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch cron status");
    }
    async getSportPerformanceReport(params, token) {
        const response = await ApiCall("POST", "/api/performance/reportV2", params, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch performance report");
    }
    async getPerformanceEntities(params, token) {
        const response = await ApiCall("GET", "/api/performance", params, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch performance entities");
    }
    async getTeamPerformanceReport(clientId, params, token) {
        return await ApiCall("GET", `/api/team-performance/${clientId}`, params, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
    }
    // 🔹 Get visible clients (permission + hide applied). status controls active vs archived (inactive).
    async getVisibleClients(token, moduleKey = MODULE_KEY, status = 'active', month) {
        let url = `/api/visible-clients?module_key=${encodeURIComponent(moduleKey)}&status=${encodeURIComponent(status)}`;
        if (month) {
            url += `&month=${encodeURIComponent(month)}`;
        }
        const response = await ApiCall("GET", url, {}, {
            Authorization: token,
            modulekey: moduleKey,
            "x-module-key": moduleKey,
        });
        if (response && "data" in response && response.status === 200)
            return response.data;
        throw new Error("Failed to fetch visible clients");
    }
    async hideClients(client_ids, reason, token, moduleKey = MODULE_KEY) {
        const response = await ApiCall("POST", "/api/hide-client", {
            module_key: moduleKey, // ✅ dynamic now
            client_ids,
            reason,
        }, {
            Authorization: token,
            modulekey: moduleKey, // ✅ dynamic now
        });
        if (response && "data" in response && response.status === 200)
            return response.data;
        throw new Error("Failed to hide clients");
    }
    async unhideClient(clientId, token, moduleKey = MODULE_KEY, client_ids) {
        const url = clientId
            ? `/api/unhide-client/${clientId}?module_key=${moduleKey}`
            : `/api/unhide-client?module_key=${moduleKey}`;
        const response = await ApiCall("POST", url, { client_ids, module_key: moduleKey }, {
            Authorization: token,
            modulekey: moduleKey, // ✅ dynamic now
        });
        if (response && "data" in response && response.status === 200)
            return response.data;
        throw new Error("Failed to unhide client");
    }
    // 🔹 Get hidden clients
    async getHiddenClients(token) {
        const response = await ApiCall("GET", `/api/hidden-clients?module_key=${MODULE_KEY}`, {}, {
            Authorization: token,
            modulekey: MODULE_KEY
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch hidden clients");
    }
}
export const accountSummaryService = new AccountSummaryService();
